export const platformId = 'ios'
export const isSafari = false
